/**
 * SiteAwareRobotsMeta — dynamically inject <meta name="robots"
 * content="noindex,nofollow"> when the current route + host combo is
 * OFF-topic for the domain (2026-09-15 SEO audit fix).
 *
 *   IndianFamilyTree.com / kerala.com / foodpulse hosts must not
 *   index /things-to-know/* (unrelated US/Canada news) or /login,
 *   /account, /dashboard, /join/, /admin, /my-content, /my-tree — these
 *   are UX / private surfaces, not search-worthy pages.
 *
 * Mounted once at the app root. Non-invasive: only manipulates a
 * single <meta> tag in <head>.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const IFT_LIKE_HOSTS = /(indianfamilytree|kerala|foodpulse|myfamilytree)/i;
const NOINDEX_PATH_REGEXES = [
  /^\/things-to-know(\/|$)/i,
  /^\/login(\/|$)/i,
  /^\/account(\/|$)/i,
  /^\/dashboard(\/|$)/i,
  /^\/join\//i,
  /^\/admin(\/|$)/i,
  /^\/my-content(\/|$)/i,
  /^\/my-tree(\/|$)/i,
  /^\/search(\/|$)/i,
];

export default function SiteAwareRobotsMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof document === "undefined") return;
    const host = window.location.hostname || "";
    const offTopicOnIftLike =
      IFT_LIKE_HOSTS.test(host) && /^\/things-to-know(\/|$)/i.test(pathname);
    const privateSurface = NOINDEX_PATH_REGEXES.some((r) => r.test(pathname));
    const shouldNoindex = offTopicOnIftLike || privateSurface;

    let tag = document.querySelector('meta[name="robots"][data-site-aware="1"]');
    if (shouldNoindex) {
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = "robots";
        tag.setAttribute("data-site-aware", "1");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", "noindex,nofollow");
    } else if (tag) {
      // Route changed to an indexable page — drop the noindex directive.
      tag.remove();
    }
  }, [pathname]);
  return null;
}
